import camelCase from 'lodash/camelCase';

export const convertKeysToCamelCase = <T, U = T>(input: T): U => {
  // Handle null or non-object types
  if (input === null || typeof input !== 'object') {
    return input as unknown as U;
  }

  // Handle arrays
  if (Array.isArray(input)) {
    return input.map(convertKeysToCamelCase) as U;
  }

  // Create a new object to convert keys
  const converted = Object.keys(input).reduce((acc, key) => {
    const camelCaseKey = camelCase(key);
    const value = Reflect.get(input, key);

    // Recursively convert nested objects and arrays
    (acc as Record<string, unknown>)[camelCaseKey] =
      value !== null && typeof value === 'object'
        ? convertKeysToCamelCase(value as Record<string, unknown>)
        : value;

    return acc;
  }, {} as U);

  return converted;
};

export function convertArrayToCamelCase<T, U = T>(arr: T[]): U[] {
  return arr.map(convertKeysToCamelCase) as unknown as U[];
}
